module.exports = __webpack_public_path__ + "img/new1-img6.de7674f1.png";